export const tableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    columnBtn: false,
    menu:false,
    indexFixed:true,
    column: [
    {
      label: '课程名称',
      prop: 'name',
      overHidden: true,
    },
    {
      label: '参与人数',
      prop: 'participationCount',
      sortable: true,
    },
    {
      label: '已完成人数',
      prop: 'completedCount',
      sortable: true,
    }]
  }